import React from "react";
import logo from "../../common/images/logo.svg";
import elle_logo from "../../common/images/elle_logo.svg";
import ilkent_logo from "../../common/images/ilkent_logo.svg";
import bgImage from "../../common/images/1.jpg";
import { useTranslation } from "react-i18next";

const Companies = () => {
  const { t } = useTranslation(["common"]);
  return (
    <section className="relative" id="companies">
      <div className="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
        <div
          className="absolute top-0 w-full h-full bg-center bg-cover"
          style={{
            backgroundImage: `url('${bgImage}')`,
            backgroundAttachment: "fixed",
          }}
        >
          <span
            id="blackOverlay"
            className="w-full h-full absolute opacity-75 bg-black"
          ></span>
        </div>
        <div className="container relative mx-auto py-10">
          <div className="items-center flex flex-wrap">
            <div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center text-white">
              <div className="pr-12">
                <h1 className="text-white font-semibold text-5xl">
                  {t("common:about")}
                </h1>
                <p className="mt-4 text-lg text-blueGray-200">
                  {t("common:about_text")}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
          style={{ transform: "translateZ(0px)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-blueGray-200 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
      </div>
      <section className="pb-10 bg-blueGray-200 -mt-24">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap">
            <div className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-xl shadow-gray-100 rounded-lg text-gray-800">
                <div className="px-4 py-5 flex-auto box">
                  <div className="text-white p-3 text-center inline-flex items-center justify-center w-36 h-36 mb-5 shadow-xl shadow-green-200 rounded-xl bg-green-400">
                    <img src={elle_logo} alt="elle" />
                  </div>
                  <h6 className="text-xl font-semibold  mt-2">ELLE</h6>
                </div>
              </div>
            </div>
            <div className="w-full md:w-4/12 px-4 text-center">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-xl shadow-gray-100 rounded-lg text-gray-800">
                <div className="px-4 py-5 flex-auto box">
                  <div className="text-white p-3 text-center inline-flex items-center justify-center w-36 h-36 mb-5 shadow-xl shadow-orange-100 rounded-xl bg-yellow-100">
                    <img src={logo} alt="Sada suw" />
                  </div>
                  <h6 className="text-xl font-semibold  mt-2">Sada suw</h6>
                </div>
              </div>
            </div>
            <div className="pt-6 w-full md:w-4/12 px-4 text-center">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-xl shadow-gray-100 rounded-lg text-gray-800">
                <div className="px-4 py-5 flex-auto box">
                  <div className="text-white p-3 text-center inline-flex items-center justify-center w-36 h-36 mb-5 shadow-xl shadow-yellow-200 rounded-xl bg-yellow-400">
                    <img src={ilkent_logo} alt="Ilkent" />
                  </div>
                  <h6 className="text-xl font-semibold  mt-2">Ilkent</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Companies;
